var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4929 23.976C11.8214 23.976 12.9083 22.8891 12.9083 21.5606H8.07743C8.07743 22.8891 9.16439 23.976 10.4929 23.976ZM17.7393 16.7296V10.691C17.7393 6.98326 15.7707 3.8794 12.3045 3.05814V2.23689C12.3045 1.23447 11.4953 0.425293 10.4929 0.425293C9.49047 0.425293 8.6813 1.23447 8.6813 2.23689V3.05814C5.22719 3.8794 3.24651 6.97119 3.24651 10.691V16.7296L0.831055 19.1451V20.3528H20.1547V19.1451L17.7393 16.7296ZM15.3238 17.9374H5.66197V10.691C5.66197 7.69582 7.48564 5.25621 10.4929 5.25621C13.5001 5.25621 15.3238 7.69582 15.3238 10.691V17.9374Z",
    fill: "#1E22AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.30f5ae84f196996efba089b1137c6e6e.svg";
export { ForwardRef as ReactComponent };